import request from '@/plugin/axios'
import { saveAs } from 'file-saver'

export function page(query) {
return request({
url: '/api/admin/sysFiles/page',
method: 'get',
params: query
})
}

export function addObj(obj) {
return request({
url: '/api/admin/sysFiles',
method: 'post',
data: obj
})
}

export function getObj(id) {
return request({
url: '/api/admin/sysFiles/' + id,
method: 'get'
})
}

export function delObj(id) {
return request({
url: '/api/admin/sysFiles/' + id,
method: 'delete'
})
}

export function putObj(id, obj) {
return request({
url: '/api/admin/sysFiles/' + id,
method: 'put',
data: obj
})
}

export function download(fileSerial) {
    if(!fileSerial)return;
    return request({
        url: '/api/admin/sysFiles/download_'+fileSerial,
        method: 'get',
        responseType:'blob'
    }).then((res)=>{
        let blob = new Blob([res.data],{type:""});
        saveAs(blob, res.filename)
    }).catch(err=>{
        console.log(err);
    })
}

export function filePreview(id) {
    return request({
        url: '/api/admin/sysFiles/preview/' + id,
        method: 'get',
        responseType: 'blob',
    }).then((res)=>{
        let blob = new Blob([res.data],{type:""});
        return window.URL.createObjectURL(blob);
    })
}